(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"] && !Shopify.designMode) return;
  try {
    
  customElements.define('back-to-top', class extends HTMLElement {
    constructor() {
      super();
    } 
    connectedCallback() {
      this.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      // this.currentScrollTop = 0;
      // this.preventReveal = false;
      window.addEventListener('scroll', this.onScrollHandler.bind(this), false);
    }

    onScrollHandler(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(scrollTop < window.innerHeight){
        this.hide();
      }else{
        this.reveal();
      }
      // if (scrollTop > this.currentScrollTop) {
      //   requestAnimationFrame(this.hide.bind(this));
      // } else {
      //   if (!this.preventReveal) {
      //     requestAnimationFrame(this.reveal.bind(this));
      //   } else {
      //     window.clearTimeout(this.isScrolling);
      //     this.isScrolling = setTimeout(() => {
      //       this.preventReveal = false;
      //     }, 66);
      //     requestAnimationFrame(this.hide.bind(this));
      //   }
      // }
      // this.currentScrollTop = scrollTop;
    }

    hide() {
      this.classList.remove('visible');
    }

    reveal() {
      this.classList.add('visible');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler, false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-subnav"] && !Shopify.designMode) return;
  try {
    
  customElements.define('sub-navigation', class extends HTMLElement {
    constructor() {
      super(); 
      this.style.height = this.querySelector('.subnavigation').offsetHeight + 'px';

      this.items = this.querySelectorAll('.subnavigation__item');
      this.items.forEach(item => {
        const href = item.getAttribute('href');
        if (href) {
          const target = document.querySelector(href);
          if (target)
            item.target = target;
        } 
      })

      this.onScrollHandle();
      window.addEventListener('scroll', this.onScrollHandle.bind(this));

      if(this.items?.length){
        this.initClick();
        this.createObserver();
      }
    }

    createObserver(){
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.intersectionRatio > 0.5){
            this.items.forEach(item => {
              if(item.target === entry.target){
                item.classList.add('active');
              }else{
                item.classList.remove('active');
              }
            }); 
          }
        });
      }, { root: null, rootMargin: '0px', threshold: [0, 0.5, 1] });
      this.items.forEach(item => {
        item.target && this.observer.observe(item.target);
      });
    }

    initClick(){
      this.items.forEach(item => {
        item.addEventListener('click', (e) => {
          const href = item.getAttribute('href');
          if (href) {
            const target = document.querySelector(href);
            if (!target) return;
            const targetTop = target.getBoundingClientRect().top;
            const scrollTop = window.scrollY;
            const targetOffset = targetTop + scrollTop - 60;
            window.scrollTo({
              top: targetOffset,
              behavior: 'smooth'
            });
          }
          this.items.forEach(item => {
            item.classList.remove('active');
          });
          item.classList.add('active');
        });
      });
    }

    onScrollHandle() {
      // 当元素将滚动出窗口时执行show方法
      if (this.getBoundingClientRect().top <= 0) {
        this.show();  
      }else{
        this.hide();
      }
    }

    show() {
      this.setAttribute('fixed', '');
    }

    hide() {
      this.removeAttribute('fixed');
    }
  })

  } catch(e) { console.error(e); }
})();
})();
